import { createContext } from "react";

const FilesContext = createContext();

export default FilesContext;
